import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'app-transcriptions-tools',
	standalone: true,
	imports: [
		CommonModule,
		ReactiveFormsModule,
		FormsModule,
		MatIconModule,
		MatButtonModule,
		MatDividerModule,
		MatSelectModule,
		TranslateModule,
		MatFormFieldModule,
		MatInputModule,
		MatDatepickerModule,
		MatNativeDateModule,
		MatDialogModule,
	],
	templateUrl: './transcriptions-tools.component.html',
	styleUrl: './transcriptions-tools.component.scss',
})
export class TranscriptionsToolsComponent {
	formGroup: FormGroup;

	// Only auto-tagging is exposed for transcriptions; kept as a list to mirror the clipping tools dropdown.
	tools = ['AUTO_TAG'];
	showDateRange = false;

	dateRangePicker: FormGroup = new FormGroup({
		dateFrom: new FormControl(),
		dateTo: new FormControl(),
	});

	constructor(
		public dialogRef: MatDialogRef<TranscriptionsToolsComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private fb: FormBuilder
	) {
		this.formGroup = this.fb.group({
			tool: [null, [Validators.required]],
		});

		// Default range: today -> today
		this.dateRangePicker.controls['dateFrom'].setValue(new Date());
		this.dateRangePicker.controls['dateTo'].setValue(new Date());
	}

	onSelectTool() {
		this.showDateRange = this.formGroup.controls['tool'].value === 'AUTO_TAG';
	}

	buttonAction() {
		const data = {
			tool: this.formGroup.controls['tool'].value,
			dateFrom: this.dateRangePicker.controls['dateFrom'].value,
			dateTo: this.dateRangePicker.controls['dateTo'].value,
		};
		this.dialogRef.close({ data });
	}

	closeDialog() {
		this.dialogRef.close();
	}
}
